"use client"

import { atom } from 'jotai';
import { AudioAdapter } from "@/features/AudioWorkstation/adapters/AudioAdapter.ts";

export const audioAdapterAtom = atom<AudioAdapter | null>(null);
